import { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import PostContactSavedSearch from './index';
import AppActions from 'app/shared/flux/actions/AppActions';

interface PostContactSavedSearchModalProps {
  onClose?: () => void;
  onHidePopup?: () => void;
  [key: string]: any;
}

/**
 * Modal wrapper for PostContactSavedSearch to work with the new modal manager system
 */
const PostContactSavedSearchModal = ({ onClose, onHidePopup, ...otherProps }: PostContactSavedSearchModalProps) => {
  const dispatch = useDispatch();

  const handleHidePopup = useCallback(() => {
    // Set the flag to prevent showing this modal again in the same session
    dispatch(AppActions.setAppStoreBool('hasShownPostContactSavedSearch', true));

    // Support both new modal manager (onClose) and legacy (onHidePopup)
    if (onClose) {
      onClose();
    } else if (onHidePopup) {
      onHidePopup();
    }
  }, [dispatch, onClose, onHidePopup]);

  return <PostContactSavedSearch onHidePopup={handleHidePopup} {...otherProps} />;
};

export default PostContactSavedSearchModal;
